import React, { useState } from 'react'
import Pricing from './Pricing'
import ThankyouPage from './ThankyouPage'

const PricingContainer = () => {
  const [paymentDone, setPaymentDone] = useState(false);
  return (
    <div>
      {
        paymentDone ? <ThankyouPage setPaymentDone={setPaymentDone}/> : <Pricing setPaymentDone={setPaymentDone}/>
      }
    </div>
  )
}

export default PricingContainer
